import { render, staticRenderFns } from "./prizecoupon.vue?vue&type=template&id=0e350ca4&scoped=true"
import script from "./prizecoupon.vue?vue&type=script&lang=js"
export * from "./prizecoupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e350ca4",
  null
  
)

export default component.exports